<div class="row modal-bar">
  <div class="col-sm-9">
    <h5 class="modal-title">{{'PASSE-PARTOUT.EVENT.QUEUE.PROGRESS.ADD.DELETE' | translate}}</h5>
  </div>
  <div class="col-sm-3">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>





<t4-list-view #passepartoutEventQueueListVw [options]="pptEventQueueListOptions" (onDataRequest)="onDataRequest($event)">

  <ng-container *t4ListActions>
  </ng-container>

  <ng-container *t4ListItem="let item">
    <!--[checked]="passepartout.Selected" -->

    <td class="text-center">
      @if (item.IsQueued) {
        <i class="ps-1 far fa-hourglass icon-24 disabled"></i>
      }
      @if (item.IsQueued === false && item.IsRunning === false && item.Failed === false) {
        <i class="ps-1 far fa-check-circle text-success icon-24"></i>
      }
      @if (item.IsQueued === false && item.IsRunning === false && item.Failed === true) {
        <i class="ps-1 fas fa-exclamation-circle text-danger icon-24"></i>
      }

      @if (item.IsRunning) {
        <div class="d-flex align-items-center justify-content-center" style="height: 16px; width: 16px;">
          <div class="sk-three-bounce" style="height: 16px; width: 16px;">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </div>
      }

    </td>

    <td>{{item.Action}}</td>
    <td>{{item.PassePartoutName}}</td>
    <td>{{item.PassePartoutCode}}</td>
    <td>{{ item.UserName | replaceOnEmpty  }}</td>
    <td>{{item.LastStatusUpdate | localDateTime | replaceOnEmpty }}</td>
    @if (item.IsRunning) {
      <td>{{"LRO.STATUS.EXECUTING" | translate | replaceOnEmpty}}</td>
    }
    @if (item.IsQueued) {
      <td>{{"LRO.STATUS.QUEUED" | translate | replaceOnEmpty}}</td>
    }
    @if (item.Failed) {
      <td>{{"LRO.STATUS.ERRORED" | translate | replaceOnEmpty}}</td>
    }
    @if (!item.IsRunning && !item.IsQueued && !item.Failed) {
      <td>{{"LRO.STATUS.SUCCEEDED" | translate | replaceOnEmpty}}</td>
    }


    <!--last column-->
    @if (item.IsRunning == true) {
      <td>
        @if (item.IsRunning) {
          <app-progress-bar [progress]="item.ProgressPercentage"></app-progress-bar>
        }
      </td>
    } @else {
      <td class="grid-action" >
        @if (item.HasReportBinary) {
          <button (click)="downloadReport(item.Id)" type="button" class="btn btn-grid btn-round mdi mdi-info mdi-file-excel"></button>
        }
      </td>
    }





  </ng-container>

</t4-list-view>

